import React, { Component } from 'react';
import { Row } from 'antd';

import IssuedGrantsWeb from './components/IssuedGrantsWeb/IssuedGrantsWeb';
import IssuedGrantsMobile from './components/IssuedGrantsMobile/IssuedGrantsMobile';
import { IssuedGrantsWrapper, MaskDiv } from './styles';
import PropTypes from 'prop-types';

class CompletedContributions extends Component {
  componentDidMount() {
    this.props.completedContribRef.current.nextElementSibling.scrollIntoView(
      false
    );
  }

  render() {
    return (
      <Row>
        <IssuedGrantsWrapper
          containerHeight='300px'
          overFlowX={true}
          overFlowY={false}
          xs={{ span: '0' }}
          lg={{ span: '24' }}
          md={{ span: '24' }}
        >
          <IssuedGrantsWeb
            issuedGrants={this.props.issuedGrants}
            config={this.props.config}
            clicked={this.props.transactionClicked}
          />
        </IssuedGrantsWrapper>
        <IssuedGrantsWrapper
          xs={{ span: '24' }}
          lg={{ span: '0' }}
          md={{ span: '0' }}
          // containerHeight='424px'
          overFlowX={false}
          overFlowY={true}
        >
          <IssuedGrantsMobile
            clicked={this.props.transactionClicked}
            issuedGrants={this.props.issuedGrants}
            config={this.props.config}
            length={this.props.issuedGrants && this.props.issuedGrants.length}
          />
        </IssuedGrantsWrapper>
        <MaskDiv />
      </Row>
    );
  }
}

export default CompletedContributions;

CompletedContributions.propTypes = {
  transactionClicked: PropTypes.func,
  issuedGrants: PropTypes.arrayOf(PropTypes.shape({
    amount: PropTypes.number,
    availableBalance: PropTypes.number,
    charityName: PropTypes.string,
    checkClearedDate: PropTypes.number,
    checkNumber: PropTypes.number,
    csrDPFlow: PropTypes.bool,
    csrFlow: PropTypes.bool,
    currentBalance: PropTypes.number,
    dateRequested: PropTypes.number,
    dpUser: PropTypes.string,
    dpUserFirstName: PropTypes.string,
    dpUserLastName: PropTypes.string,
    dpUserMiddleName: PropTypes.string,
    dpUserPrefix: PropTypes.string,
    dpUserSuffix: PropTypes.string,
    enteredDate: PropTypes.number,
    grantAgreement: PropTypes.bool,
    isRecurring: PropTypes.string,
    issuedate: PropTypes.number,
    purpose: PropTypes.object,
    status: PropTypes.string,
    stopAndReissueChkDate: PropTypes.number,
    txnId: PropTypes.number,
    userName: PropTypes.string,
    x: PropTypes.number,
    y3: PropTypes.bool,
    y5: PropTypes.bool,
  }))
}
